import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react'

import { useActiveUser } from 'Hooks'

export const NewJoinerRedirect = observer(() => {
  const { activeEmployee } = useActiveUser()

  if (activeEmployee?.caseitems?.totalCount === 0) {
    return <Navigate to={`order/new`} />
  }

  return (
    <Navigate to={`orders/${activeEmployee?.caseitems?.caseItems![0]!.id}`} />
  )
})
